import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useSearchParams } from 'react-router-dom';
import Login from './pages/Login';
import MainLayout from './layouts/MainLayout';
import Dashboard from './pages/Dashboard';
import UserList from './pages/UserList';
import ConsumptionStats from './pages/ConsumptionStats';
import BillingDetails from './pages/BillingDetails';

function PrivateRoute({ children }) {
  const [params] = useSearchParams();
  const urlToken = params.get('agent_token');
  const storedToken = localStorage.getItem('agent_token');

  useEffect(() => {
    if (urlToken && urlToken !== storedToken) {
      localStorage.setItem('agent_token', urlToken);
      const newUrl = window.location.pathname + window.location.hash;
      window.history.replaceState({}, '', newUrl);
    }
  }, [urlToken, storedToken]);

  const token = urlToken || storedToken;
  return token ? children : <Navigate to="/login" />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<PrivateRoute><MainLayout /></PrivateRoute>}>
        <Route index element={<Navigate to="/dashboard" />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="users" element={<UserList />} />
        <Route path="stats" element={<ConsumptionStats />} />
        <Route path="billing" element={<BillingDetails />} />
      </Route>
    </Routes>
  );
}
